module.exports = __webpack_public_path__ + "img/CompanyLogo.6195d520.jpg";